<div title="" style="text-align: left;">
  <p>
    Associa le unità organizzative all'utente applicativo <strong>{{ element.email }}</strong>.
  </p>
  <form [formGroup]="form">
    <div class="row">
      @for (uo of uoList; track uo) {
      <div class="col-12" style="text-align: left">
        <it-checkbox toggle="true" [formControlName]="'uo-' + uo.idUnitaOrganizzativa"
          [label]="uo.descrizione"
          [title]="uo.descrizione"></it-checkbox>
      </div>
      }
      @if (form.hasError('atLeastOneCheckboxChecked')) {
        <ng-container error>
          <div class="text-danger">Seleziona almeno una unità organizzativa</div>
        </ng-container>
        }
    </div>
  </form>
</div>
<div class="modal-footer" title="Salva">
  <button itButton="primary" size="sm" type="button" [disabled]="form.invalid || ente.isSolaLettura || !editable"
    (click)="submit()" >Salva</button>
</div>
